import React from 'react';
import { PhoneCallIcon, SmartphoneIcon, StarIcon } from 'lucide-react';
const valueProps = [{
  icon: PhoneCallIcon,
  title: 'Never Miss Another Call',
  body: "Our AI Phone Attendant answers 24/7, books appointments straight to your calendar, and texts you a summary after every call. It's not a script reader — it actually handles the conversation."
}, {
  icon: StarIcon,
  title: 'Your Reputation, Automated',
  body: 'Automatic AI review responses written in your voice, plus review outreach that keeps new 5-star reviews coming in without you lifting a finger.'
}, {
  icon: SmartphoneIcon,
  title: 'Run Your Business From Your Phone',
  body: 'A real business phone system plus a mobile app so you can manage leads, customers, and your calendar from anywhere — not stuck at a desk.'
}];
export function ValueProps() {
  return <section className="bg-brand-white" aria-labelledby="value-heading" data-id="element-173" data-mp="1zspwfmuua42j">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20 lg:py-24" data-id="element-174" data-mp="1zqv8s0s6nxur">
        <div className="max-w-3xl" data-id="element-175" data-mp="1ma66e1k06c0b">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-brand-red sm:text-xs" data-id="element-176" data-mp="1mck2mdqf5u9g">
            The full system
          </p>
          <h2 id="value-heading" className="mt-4 font-display text-3xl font-extrabold leading-[1.1] tracking-tight sm:text-4xl lg:text-[2.75rem]" data-id="element-177" data-mp="1cjuqrhqyiedl">
            Everything Your Business Needs, Not Just a Website.
          </h2>
        </div>

        <div className="mt-12 grid items-stretch gap-6 lg:grid-cols-3 lg:gap-8" data-id="element-178" data-mp="ylenk0saz607">
          {valueProps.map(({
          icon: Icon,
          title,
          body
        }) => <article key={title} className="flex flex-col border-t-4 border-brand-red bg-brand-light p-7 sm:p-8" data-id="element-179" data-mp="tmk2es6v55cx">
              <span className="inline-flex h-12 w-12 flex-none items-center justify-center bg-brand-black" data-id="element-180" data-mp="2o0l19d2exsd0">
                <Icon className="h-6 w-6 text-brand-white" aria-hidden="true" data-id="element-181" data-mp="2j0qad9in12ry" />
              </span>
              <h3 className="mt-6 font-display text-xl font-extrabold leading-snug tracking-tight sm:text-2xl" data-id="element-182" data-mp="hbj0iivn4qv3">
                {title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-brand-gray sm:text-base" data-id="element-183" data-mp="m4lugs4by2bt">{body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}